// client/src/services/progressService.ts

export interface SubjectProgress {
    subject: string;
    progress: number;
  }
  
  const API_URL = process.env.REACT_APP_API_URL || "https://lavernaibackend.onrender.com/api";
  
  const progressService = {
    getProgressData: async (): Promise<SubjectProgress[]> => {
      const response = await fetch(`${API_URL}/progress`);
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Failed to fetch progress data");
      }
      const data = await response.json();
      // Assume the backend returns an object with a property named 'progressData'
      return data.progressData;
    },
  };
  
  export default progressService;
  